import { Button } from 'src/components';
import EmailConfirmationWrapper from 'src/components/Wrapper/EmailConfirmationWrapper';

type CheckEmailData = {
  isCheckedEmail: boolean;
  email: string;
};

type CheckEmailProps = CheckEmailData & {
  updateFields: (fields: Partial<CheckEmailData>) => void;
  nextStep: () => void;
};

const EmailVerified = ({ nextStep, updateFields, email }: CheckEmailProps) => {
  return (
    <EmailConfirmationWrapper>
      <h1 className="text-blue-950 text-[24px] font-bold">
        Email Verified Successfully!
      </h1>
      <div className="w-[432px] text-center">
        <span className="text-blue-950 text-sm font-medium font-SFProDisplay ">
          Your email has been successfully verified.
        </span>
      </div>
      <Button
        variant="normal"
        size="sm"
        label="Continue"
        className="block w-[360px] mt-10"
        type="submit"
        onClick={() => {
          updateFields({ isCheckedEmail: true });
          nextStep();
        }}
      />
    </EmailConfirmationWrapper>
  );
};

export default EmailVerified;
